import { render } from "./EventUpdate.vue?vue&type=template&id=13a16590"
import script from "./EventUpdate.vue?vue&type=script&lang=js"
export * from "./EventUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__